import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { AuditLogRow, AuditLogQuery } from "@avestate/shared";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

const AuditLogsResponse = z.object({
  items: z.array(AuditLogRow),
  limit: z.number(),
});

export function useAuditLogs(filters: z.input<typeof AuditLogQuery> = {}) {
  const { session } = useAuth();
  const token = session?.access_token;
  return useQuery({
    queryKey: ["audit_logs", filters],
    enabled: !!token,
    queryFn: () => apiFetch("/api/v1/admin/audit-logs", token!, AuditLogsResponse, { query: filters as never }),
  });
}
